<template>
  <div class="logincss">
    <el-row type="flex"
            style="height: 100%;"
            align="middle"
            justify="center">
      <div style="height: 500px;box-shadow:0 0 15px rgba(236,249,247,0.2);overflow: hidden;">
        <div style="display:inline-block;height: 100%;border-radius:15px;">
          <img style="height:100%;"
               src="../../public/img/login_left.png" />
        </div>
        <div style="display:inline-block;height: 100%;position: relative;border-radius:15px;">
          <img style="height:100%;"
               src="../../public/img/login_right.png" />
          <div style="position: absolute;top:0;left:0;width:100%;height: 100%;">
            <div class="login-box">
              <div style="display:flex;align-items:flex-end;justify-content:center;border-bottom:1px solid #eaeaea;">
                <div @click="loginType='wxlogin'"
                     :class="loginType==='wxlogin'?'tab-bar-item tab-bar-item-active':'tab-bar-item'">扫码登录</div>
                <div @click="loginType='account'"
                     :class="loginType==='account'?'tab-bar-item tab-bar-item-active':'tab-bar-item'">账号登录</div>
              </div>
              <iframe v-show="loginType==='wxlogin'"
                      sandbox="allow-scripts allow-same-origin allow-top-navigation"
                      scrolling="no"
                      style="margin-top:40px;"
                      width="300"
                      height="300"
                      frameBorder="0"
                      allowTransparency="true"
                      :src="setSrc"></iframe>
              <div v-show="loginType==='account'"
                   class="input-form">
                <div class="input-box">
                  <el-input v-model="loginAccount"
                            :maxlength="11"
                            @keyup.enter.native="$refs.pass.focus()"
                            placeholder="请输入您的手机号码">
                    <i slot="prefix"
                       class="iconfont icon-yonghu"></i>
                  </el-input>
                </div>
                <div class="input-box">
                  <el-input ref="pass"
                            v-model="loginPassword"
                            show-password
                            @keyup.enter.native="$refs.yzm.focus()"
                            placeholder="请输入登录密码">
                    <i slot="prefix"
                       class="iconfont icon-lock-full"></i>
                  </el-input>
                </div>
                <div style="display:flex;align-items:center;">
                  <div class="input-box"
                       style="flex:1;">
                    <el-input v-model="loginYzm"
                              :maxlength="4"
                              ref="yzm"
                              @keyup.enter.native="login()"
                              placeholder="请输入验证码">
                      <i slot="prefix"
                         :style="{color:identifyStatus?'#42c3af':''}"
                         class="iconfont icon-yanzhengma-xuanzhong"></i>
                    </el-input>
                  </div>
                  <div style="margin-left:10px;margin-top:30px;cursor: pointer;"
                       @click="refreshCode">
                    <identify ref="identify"
                              :identifyCode="identifyCode"></identify>
                  </div>
                </div>
                <div style="display:flex;align-items:center;margin-top:15px;padding:0 6px;">
                  <el-checkbox v-model="agrement"></el-checkbox>
                  <div style="margin-left:6px;">同意并遵守<a target="_blank"
                       rel="noopener noreferrer"
                       href="https://datainside.com.cn/protocol/"
                       class="link">{{'《用户协议》'}}</a>和<a target="_blank"
                       href="https://datainside.com.cn/yszc/"
                       rel="noopener noreferrer"
                       class="link">{{'《隐私政策》'}}</a></div>
                </div>
                <div style="margin-top:10px;display:flex;justify-content:center;padding:0;">
                  <el-button type="primary"
                             :disabled="!canLogin"
                             @click="login"
                             style="flex:1;border-radius: 25px;">{{loging?'正在登录...':'登录'}}<i v-show="loging"
                       style="margin-left: 10px;"
                       class="el-icon-loading"></i></el-button>
                </div>
                <!-- <div style="text-align:left;margin-top:20px;padding-left:15px;">
                <el-checkbox v-model="bindWx">绑定微信，便捷扫码登录</el-checkbox>
              </div> -->
                <div class="more-box">
                  <span @click="toRegister"
                        style="cursor: pointer;">没有账号，立即注册</span>
                  <span @click="showUnbindWxDialog"
                        style="cursor: pointer;">解绑微信</span>
                  <el-dropdown @command="handleCommand"
                               placement="bottom">
                    <span style="cursor: pointer;color:#42c3af;">注销</span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="cancellation-account"
                                        style="color:#42c3af;">账号密码注销</el-dropdown-item>
                      <el-dropdown-item command="cancellation-weixin"
                                        style="color:#42c3af;">微信扫码注销</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-row>
    <el-dialog :title="dialogTitle"
               width="400px"
               @close="closeWxDialog"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :visible.sync="bindWxDialogVisiable">
      <div style="display:flex;flex-direction:column;align-items:center;">
        <div v-show="dialogType==='cancellation'"
             style="color:red;"><i class="el-icon-warning-outline"></i>账号注销后将清除所有信息</div>
        <div v-show="bindUserPhone"
             style="font-size:14px;color:#333;font-weight:bold;">{{'绑定账号：' + bindUserPhone}}</div>
        <iframe sandbox="allow-scripts allow-same-origin allow-top-navigation"
                scrolling="no"
                width="300"
                height="260"
                frameBorder="0"
                allowTransparency="true"
                :src="bindSrc"></iframe>
        <div style="">{{'使用微信扫一扫'+ dialogTips}}</div>
        <div @click="cancelBind"
             class="dialogCancel-btn">{{dialogType==='bind'?'暂不绑定,立即登录':'取消'}}</div>
      </div>
    </el-dialog>
    <el-dialog title="账号注销"
               width="450px"
               custom-class="cancellationDialog"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :visible.sync="cancellationDialogVisiable">
      <div style="display:flex;flex-direction:column;align-items:center;"
           v-loading="cancellationing">
        <div style="color:red;"><i class="el-icon-warning-outline"></i>账号注销后将清除所有信息</div>
        <div class="input-form">
          <div class="input-box">
            <el-input v-model="cancellationAccount"
                      :maxlength="11"
                      @keyup.enter.native="$refs.cancellationpass.focus()"
                      placeholder="请输入您的手机号码">
              <i slot="prefix"
                 class="iconfont icon-yonghu"></i>
            </el-input>
          </div>
          <div class="input-box">
            <el-input ref="cancellationpass"
                      v-model="cancellationPassword"
                      show-password
                      @keyup.enter.native="$refs.cancellationYzm.focus()"
                      placeholder="请输入登录密码">
              <i slot="prefix"
                 class="iconfont icon-lock-full"></i>
            </el-input>
          </div>
          <div style="display:flex;align-items:center;">
            <div class="input-box"
                 style="flex:1;">
              <el-input v-model="cancellationYzm"
                        :maxlength="4"
                        ref="cancellationYzm"
                        @keyup.enter.native="cancellation()"
                        placeholder="请输入验证码">
                <i slot="prefix"
                   :style="{color:cancellationIdentifyStatus?'#67C23A':''}"
                   class="iconfont icon-yanzhengma-xuanzhong"></i>
              </el-input>
            </div>
            <div style="margin-left:10px;margin-top:30px;cursor: pointer;"
                 @click="refreshCode">
              <identify ref="cancellationIdentify"
                        :identifyCode="cancellationIdentifyCode"></identify>
            </div>
          </div>
          <div style="margin-top:40px;display:flex;justify-content:center;padding:0;">
            <el-button type="primary"
                       :disabled="!canCancellation"
                       @click="cancellation"
                       style="flex:1;border-radius: 25px;">注销</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import identify from '@/components/identify';
import base64 from '@/request/base64';
export default {
  inject: ['reload'],//注入App里的reload方法
  components: { identify },
  name: 'Auth',
  data () {
    return {
      loging: false,
      bindUserId: '',//微信绑定的用户id
      bindUserPhone: '',//微信绑定的用户电话
      bindWx: true,//账号是否绑定微信
      bindWxDialogVisiable: false,
      dialogType: '',//bind or unbind
      cancellationDialogVisiable: false,
      openLinks: null,//取消绑定微信时跳转的链接
      loginType: 'wxlogin',//wxlogin/account
      //应用唯一标识，在微信开放平台提交应用审核通过后获得
      appid: 'wx59ae7100c990f202',
      //应用授权作用域，拥有多个作用域用逗号（,）分隔，网页应用目前仅填写snsapi_login即可
      scope: 'snsapi_login',
      //重定向地址，需要进行UrlEncode
      redirect_uri: encodeURIComponent('https://datainside.com.cn/auth/callback'),
      //用于保持请求和回调的状态，授权请求后原样带回给第三方。该参数可用于防止csrf攻击（跨站请求伪造攻击），建议第三方带上该参数，可设置为简单的随机数加session进行校验
      state: '',
      //提供"black"、"white"可选，默认为黑色文字描述。详见文档底部FAQ
      theme: 'black',
      // 自定义样式链接，第三方可根据实际需求覆盖默认样式。详见文档底部FAQ
      href: 'data:text/css;base64,',
      // true：手机点击确认登录后可以在 iframe 内跳转到 redirect_uri，false：手机点击确认登录后可以在 top window 跳转到 redirect_uri。默认为 false。
      self_redirect: 'default',
      // sdk的扩展字符串，但是在这里就默认了jssdk，暂时不建议修改
      login_type: 'jssdk',
      loginAccount: process.env.NODE_ENV === 'production' ? '' : '13540608634',
      loginPassword: process.env.NODE_ENV === 'production' ? '' : 'liupiaopiao_999',
      loginYzm: '',
      identifyCode: '',
      cancellationAccount: process.env.NODE_ENV === 'production' ? '' : '13540608634',
      cancellationPassword: process.env.NODE_ENV === 'production' ? '' : 'liupiaopiao_999',
      cancellationYzm: '',
      cancellationIdentifyCode: '',
      cancellationing: false,
      identifyCodes: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'], //根据实际需求加入自己想要的字符
      agrement: false,
    }
  },
  computed: {
    dialogTitle () {
      let res = '';
      if (this.dialogType === 'bind') {
        res = '绑定微信';
      } else if (this.dialogType === 'unbind') {
        res = '解绑微信';
      } else if (this.dialogType === 'cancellation') {
        res = '注销账号';
      }
      return res;
    },
    dialogTips () {
      let res = '';
      if (this.dialogType === 'bind') {
        res = '绑定账号';
      } else if (this.dialogType === 'unbind') {
        res = '解绑账号';
      } else if (this.dialogType === 'cancellation') {
        res = '注销账号';
      }
      return res;
    },
    canLogin () {
      if (this.loginAccount && this.loginPassword && this.loginYzm && this.identifyStatus) {
        return true;
      } else {
        return false;
      }
    },
    canCancellation () {
      if (this.cancellationAccount && this.cancellationPassword && this.cancellationYzm && this.cancellationIdentifyStatus) {
        return true;
      } else {
        return false;
      }
    },
    identifyStatus () {
      return this.loginYzm.toUpperCase() === this.identifyCode.toUpperCase();
    },
    cancellationIdentifyStatus () {
      return this.cancellationYzm.toUpperCase() === this.cancellationIdentifyCode.toUpperCase();
    },
    setSrc () {
      var _url = 'https://open.weixin.qq.com/connect/qrconnect?appid=' + this.appid
        + '&scope=' + this.scope
        + '&redirect_uri=' + this.redirect_uri
        + '&state=' + this.state
        + '&login_type=' + this.login_type
        + '&style=' + this.theme
        + '&self_redirect=' + this.self_redirect
        + '&href=' + this.href + base64.encode('.impowerBox .qrcode {width: 220px;}.impowerBox .title {display: none;}.impowerBox .info {width: 300px;}.impowerBox .status {text-align:center;}.impowerBox .status_txt {text-align:left;}');
      return _url;
    },
    bindSrc () {
      let rediectParma = '';
      if (this.dialogType === 'bind') {
        rediectParma = '?uid=' + this.bindUserId;
      } else if (this.dialogType === 'unbind') {
        rediectParma = '?unbind=1';
      } else if (this.dialogType === 'cancellation') {
        rediectParma = '?cancellation=1';
      }
      var _url = 'https://open.weixin.qq.com/connect/qrconnect?appid=' + this.appid
        + '&scope=' + this.scope
        + '&redirect_uri=' + encodeURIComponent('https://datainside.com.cn/auth/callback' + rediectParma)
        + '&state=' + this.state
        + '&login_type=' + this.login_type
        + '&style=' + this.theme
        + '&self_redirect=' + this.self_redirect
        + '&href=' + this.href + base64.encode('.impowerBox .qrcode {width: 220px;}.impowerBox .title {display: none;}.impowerBox .info {display: none;}');
      return _url;
    }
  },
  mounted () {
    if (window.self != window.top) {
      window.top.location.href = window.location.href;
    }
    this.refreshCode();
  },
  methods: {
    cancellation () {
      //注销
      if (this.cancellationAccount == '' || this.cancellationPassword == '') {
        this.$message.error('请输入账户密码！');
        return;
      }
      if (!this.cancellationIdentifyCode) {
        this.$message.error('验证码错误！');
        return;
      }
      let param = {
        username: this.$aes.encrypt(this.cancellationAccount),
        password: this.$aes.encrypt(this.cancellationPassword)
      };
      this.cancellationing = true;
      this.refreshCode();
      this.$request.post('api/Platform/IntegrationUserAuth/UnLogOffByUserName/', param).then((response) => {
        this.cancellationing = false;
        if (response.code === '000000') {
          if (response.data.state) {
            //注销成功
            this.$alert('您的账号已注销！', '提示', {
              confirmButtonText: '知道了',
              type: 'success',
              callback: action => {
                this.reload();
              }
            });
          } else {
            //注销失败
            this.$alert(response.message, '账号注销失败', {
              confirmButtonText: '好的',
              type: 'error'
            });
          }
        } else {
          this.$alert(response.message, '账号注销失败', {
            confirmButtonText: '请重试',
            type: 'error'
          });
        }
      })
        .catch((e) => {
          this.cancellationing = false;
          this.$alert(response.message, '账号注销失败', {
            confirmButtonText: '请重试',
            type: 'error'
          });
        });
    },
    handleCommand (command) {
      if (command === 'cancellation-account') {
        this.cancellationDialogVisiable = true;
        this.refreshCode();
      } else {
        this.dialogType = 'cancellation';
        this.bindWxDialogVisiable = true;
      }
    },
    closeWxDialog () {
      if (this.dialogType === 'bind') {
        this.openBIUrl(this.openLinks);
      }
    },
    cancelBind () {
      if (this.dialogType === 'bind') {
        this.openBIUrl(this.openLinks);
      }
      this.bindWxDialogVisiable = false;
    },
    login () {
      if (this.loginAccount == '' || this.loginPassword == '') {
        this.$message.error('请输入账户密码！');
        return;
      }
      if (!this.identifyStatus) {
        this.$message.error('验证码错误！');
        return;
      }
      if (!this.agrement) {
        this.$message.info('请阅读并同意《用户协议》和《隐私政策》！');
        return;
      }
      this.loging = true;
      this.refreshCode();
      this.loginYzm = '';
      let param = {
        username: this.$aes.encrypt(this.loginAccount),
        password: this.$aes.encrypt(this.loginPassword)
      };
      this.$request.post('api/Platform/IntegrationUserAuth/UamAuths/', param).then((response) => {
        this.loging = false;
        if (response.code === '000000') {
          if (this.bindWx && !response.data.user.openid) {//勾选了绑定微信
            this.$confirm('你的账号还未绑定微信, 是否绑定?', '提示', {
              confirmButtonText: '去绑定',
              cancelButtonText: '暂不绑定',
              type: 'info'
            }).then(() => {
              this.bindUserId = response.data.user.id;
              this.bindUserPhone = response.data.user.phone;
              this.openLinks = response.data.links;
              this.dialogType = 'bind';
              this.bindWxDialogVisiable = true;
            }).catch(() => {
              this.openBIUrl(response.data.links);
            });
          } else {
            this.openBIUrl(response.data.links);
          }
        } else {
          this.$message.error(response.message);
        }
      })
        .catch((e) => {
          this.loging = false;
          this.$message.error("连接失败！请重试！");
        });
    },
    openBIUrl (links) {
      if (links && links.length > 0) {
        window.location.href = links[0].url;
      } else {
        alert('没有可使用的系统!');
      }
    },
    // 生成随机数
    randomNum (min, max) {
      max = max + 1
      return Math.floor(Math.random() * (max - min) + min);
    },
    // 更新验证码
    refreshCode () {
      if (this.cancellationDialogVisiable) {
        this.cancellationIdentifyCode = "";
      } else {
        this.identifyCode = "";
      }
      this.makeCode(4);
    },
    // 随机生成验证码字符串
    makeCode (len) {
      let cc = '';
      for (let i = 0; i < len; i++) {
        let c1 = this.identifyCodes[this.randomNum(0, this.identifyCodes.length - 1)];
        cc += c1.toUpperCase();
      }
      if (this.cancellationDialogVisiable) {
        this.cancellationIdentifyCode = cc;
      } else {
        this.identifyCode = cc;
      }
    },
    toRegister () {
      this.$router.push('/register');
    },
    toCancellation () {
      this.$router.push('/cancellation');
    },
    showUnbindWxDialog () {
      this.dialogType = 'unbind';
      this.bindWxDialogVisiable = true;
    }
  }
}
</script>

<style lang="scss">
a.link {
  text-decoration: none;
}
a.link,
a.link:hover {
  color: #42c3af;
}
a.link:hover {
  text-decoration: underline;
}
.dialogCancel-btn {
  color: #666;
  cursor: pointer;
  margin-top: 15px;
}
.dialogCancel-btn:hover {
  color: #333;
  text-decoration: underline;
}
.cancellationDialog {
  .el-dialog__body {
    padding-top: 0;
  }
}
.logincss {
  width: 100%;
  height: 100%;
  min-width: 960px;
  min-height: 590px;
  background-image: url(../../public/img/loginbg.jpg);
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .more-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    font-size: 13px;
    color: #42c3af;
    padding: 0 10px;
    span:hover {
      text-decoration: underline;
    }
  }
  .input-form {
    padding: 10px 20px;
    .login-btn {
      flex: 1;
      background-color: #42c3af;
      color: #ffffff;
      cursor: pointer;
      line-height: 42px;
      border-radius: 25px;
      font-size: 18px;
    }
    .login-btn-disabled {
      background-color: #c6c9fc;
      color: #ffffff;
      cursor: not-allowed;
    }
    .input-box {
      margin-top: 30px;
      // display: flex;
      // align-items: center;
    }
    .input-box .el-input__inner {
      letter-spacing: 1px;
      font-size: 14px;
      padding-left: 45px;
      padding-right: 20px;
      border-radius: 25px;
      background-color: #f7f8fa;
    }
    .input-box .el-input__prefix {
      left: 20px;
      line-height: 40px;
    }
  }
  .tab-bar-item {
    line-height: 50px;
    border-bottom-width: 2px;
    font-size: 15px;
    color: #999;
    cursor: pointer;
    border-bottom-style: solid;
    border-bottom-color: transparent;
  }
  .tab-bar-item-active {
    color: #333;
    border-bottom-color: #42c3af;
  }
  .tab-bar-item + .tab-bar-item {
    margin-left: 40px;
  }

  .login-box {
    text-align: center;
    padding: 20px 40px;
  }
}
</style>
